
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.575 4.625c2.536-2.85 6.543-4.686 10.056-4.623.2.005.361.166.366.366.082 3.51-1.77 7.515-4.62 10.057a9.5 9.5 0 01-2.754 6.5.424.424 0 01-.29.12.343.343 0 01-.107-.017c-.134-.045-.245-.148-.265-.29l-.414-2.89-.4.357a.373.373 0 01-.515-.014l-4.82-4.82a.375.375 0 01-.015-.516l.357-.4-2.89-.414a.375.375 0 01-.21-.638 9.514 9.514 0 016.521-2.778zm5.275 2.4c.48 0 .96-.183 1.325-.549.732-.73.732-1.92 0-2.652a1.876 1.876 0 00-2.651 0 1.88 1.88 0 000 2.652c.365.366.845.549 1.326.549zM.016 17.517c.123-.41 1.224-4.036 2.027-4.839a2.32 2.32 0 013.277 0 2.322 2.322 0 010 3.279c-.802.802-4.427 1.904-4.837 2.027a.374.374 0 01-.467-.467z","fill":"#F8BF1E"}})])
          )
        }
      }
    